import { useState } from 'react';
import { useNavigate } from 'react-router';
import { paths } from '../../../common/constants/pathVariables.js';
import { submitProductOrder } from '../../../common/fetch.js';

type SubmitStatus = 'idle' | 'loading' | 'success' | 'error';

interface UseSubmitCardPaymentOrderCoCoReturn {
  submitStatus: SubmitStatus;
  submitCardPaymentOrder: (orderId: string, transactionId: string) => Promise<void>;
}

/**
 * Hook to submit a CoCo product order after returning from Nets card payment.
 *
 * the backend validates the payment with Nets before orchestrating the order.
 */
export const useSubmitCardPaymentOrderCoCo = (): UseSubmitCardPaymentOrderCoCoReturn => {
  const navigate = useNavigate();
  const [submitStatus, setSubmitStatus] = useState<SubmitStatus>('idle');

  const submitCardPaymentOrder = async (orderId: string, transactionId: string): Promise<void> => {
    setSubmitStatus('loading');

    try {
      await submitProductOrder(orderId, undefined, transactionId);
      setSubmitStatus('success');
      navigate(paths.PLACE_ORDER_THANK_YOU);
    } catch {
      setSubmitStatus('error');
    }
  };

  return { submitStatus, submitCardPaymentOrder };
};
